<script lang="ts">
  import { reportUiFailure } from "$lib/report-failure.js";
  import { onDestroy, type Snippet } from "svelte";
  import { Button } from "$lib/components/ui/button/index.js";
  import { getSavedSession } from "$lib/core/saved-session.js";
  import { desktopCredentials, desktopCredentialProblem, followDesktopCredentialProblem } from "$lib/core/desktop-credentials.js";
  let { children }: { children: Snippet } = $props();
  function prepare(): string | undefined {
    if (desktopCredentials()) {
      try { getSavedSession(); }
      catch { /* intentional: the credential boundary reports once; show recovery instead of login. */ }
    }
    return desktopCredentialProblem();
  }
  let problem = $state(prepare());
  onDestroy(followDesktopCredentialProblem((message) => { problem = message; }));
  function retry() {
    try {
      desktopCredentials()?.retry();
      window.location.reload();
    } catch {
      reportUiFailure("auth.desktop_credential_retry", new Error("desktop credential retry unavailable"));
    }
  }
</script>

{#if problem}
  <section role="alert" class="mx-auto flex max-w-lg flex-col gap-4 p-8 text-content">
    <h1 class="text-lg font-semibold">Your saved sign-in needs attention</h1>
    <p>{problem}</p>
    <Button onclick={retry}>Try again</Button>
  </section>
{:else}
  {@render children()}
{/if}
